import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useState, useEffect } from "react";
import moment from "moment";
import Select from "react-select";
import ManualWinnerServices from "../../../services/ManualWinnerServices";

const normalizeYantraId = (v) => {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : undefined;
};

const mapYantraOptions = (list) =>
  (Array.isArray(list) ? list : []).map((o) => ({
    ...o,
    value: normalizeYantraId(o.value) ?? o.value,
  }));

// Validation Schema
const validationSchema = Yup.object().shape({
  yantra_id: Yup.number().required("Please select a yantra"),
});

const EditManualWinnerModal = (props) => {
  const {
    editMWModal,
    setEditMWModal,
    editMWData,
    setEditMWData,
    activeGame,
    getManualWinnerData,
  } = props;

  const manualWinnerApi = new ManualWinnerServices();
  const [isLoading, setIsLoading] = useState(false);
  const [yantraList, setYantraList] = useState([]);

  const initialValues = {
    date_filter: "today",
    yantra_id: normalizeYantraId(editMWData?.winner_yantra),
    session_id: editMWData?.id,
  };

  const onClose = () => {
    setEditMWModal(false);
    setEditMWData(null);
  };

  const getSessionList = async (date_filter) => {
    try {
      const response = await manualWinnerApi.getSessionList(activeGame, date_filter);
      if(response.isSuccess){
        setYantraList(mapYantraOptions(response.yantraList));
      } else {       
        setYantraList([]);  
        toast.error(response.message);
      }
    }
    catch(error){
      console.error("Error in getSessionList:", error);     
      setYantraList([]);
      toast.error("Error in get session list");
    }
  }

  useEffect(() => {
    if(editMWModal){
      getSessionList(initialValues.date_filter);
    }
  }, [editMWModal]);

  return (
    <Modal
      show={editMWModal}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="md"
    >
      <div className="modal-header border-0 pb-0">
        <h5 className="modal-title">
          Update Manual Winner [
          {activeGame === "3min" ? "3 Min Session" : "5 Min Session"}]
        </h5>
        <button className="btn" onClick={onClose}>
          <RiCloseLargeFill size={20} />
        </button>
      </div>
      <hr className="my-1" />
      <Formik
        key={editMWData?.id ?? "closed"}
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setIsLoading(true);
          setSubmitting(true);
          const payload = {
            game: activeGame,
            date_filter: values.date_filter,
            session_id: values.session_id,
            yantra_id: values.yantra_id,
          };
          manualWinnerApi
            .updateManualWinner(payload)
            .then((response) => {
              if (response.isSuccess) {
                toast.success(response.message);
                onClose();
                getManualWinnerData();
              } else {
                toast.error(response.message);
              }
            })
            .catch((error) => {
              console.error("Error in updateManualWinner:", error);
              toast.dismiss();
              toast.error(
                error?.response?.data?.message ||
                  "Error in update manual winner",
              );
            })
            .finally(() => {
              setIsLoading(false);
              setSubmitting(false);
            });
        }}
      >
        {({ errors, touched, isSubmitting, values, setFieldValue }) => (
          <Form className="addAdmin-form">
            <Modal.Body className="modal-body-scroll">
            <div className="form-group mb-2">
                <label htmlFor="yantra_id" className="form-label mb-0">
                  Select Yantra <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Select
                    className="mt-1 w-100"
                    placeholder="Select..."
                    options={yantraList}
                    value={
                      yantraList.find(
                        (opt) =>
                          normalizeYantraId(opt.value) ===
                          normalizeYantraId(values.yantra_id),
                      ) || null
                    }
                    id="yantra_id"
                    name="yantra_id"
                    onChange={(selectedItems) => {
                      setFieldValue(
                        "yantra_id",
                        selectedItems
                          ? normalizeYantraId(selectedItems.value)
                          : undefined,
                      );
                    }}
                  />
                </div>
                <ErrorMessage name="yantra_id">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>
              {/* Submit Button */}
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="submit"
                  className="add_admin-btn"
                  disabled={isSubmitting || isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    "Update Now"
                  )}
                </button>
              </div>
            </Modal.Body>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default EditManualWinnerModal;
